import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppShell } from '../features/shell/AppShell.js';

/**
 * The authenticated half of the app.
 *
 * This guard is a convenience, not the security boundary: the server already
 * answers any page request without a session with a 302 to /login before
 * index.html is sent, and every API route with a 401. This exists so that a
 * session which expires *while the app is open* lands the user somewhere
 * sensible instead of on a wall of failed requests.
 */
export const Route = createFileRoute('/_authed')({
  beforeLoad: ({ context, location }) => {
    if (!context.session) {
      throw redirect({
        to: '/login',
        search: { next: location.href },
      });
    }
    return { session: context.session };
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
